export const as = {
    "TRIGGER_LISTEN": "ট্ৰিগাৰসমূহৰ বাবে শ্ৰবণ কৰি আছে",
    "ASSIST_EMPTY_MSG": "এজেণ্ট AI আপোনাৰ সংলাপকৈ সক্ৰিয়ভাৱে শ্ৰবণ কৰি আছে আৰু ট্ৰিগাৰ হোৱাৰ সময়ত স্বত মুহী সহায্য কৰিবলৈ প্ৰস্তুত।",
    "MYBOT_TRIGGET_LISTEN": "বৰ্তমানে কোনো সক্ৰিয় My Bot কাম নাই।",
    "MYBOT_EMTPY_MSG": "মোৰ My Botত কৰ্ম আৰম্ভ কৰিবলৈ, অনুসন্ধান টেবললৈ যাওক আৰু আপোনাৰ ইচ্ছা কৰা কৰ্মৰ বাবে \"\"এজেণ্ট ইনপুটসহ চলব\"\" বিকল্পটি বাচন কৰক।",
    "PROACTIVE_MODE": "প্ৰোএক্টিভ মোড",
    "SETTINGS": "ছেটিংছসমূহ",
    "HELP_AND_SUPPORT": "সহায় আৰু সমৰ্থন",
    "HELP": "সহায়",
    "LANGUAGE": "ভাষা",
    "THEME": "থীম",
    "AUTOMATIC": "স্বয়ংক্ৰিয়",
    "DARK": "অন্ধকাৰ",
    "LIGHT": "আলো",
    "THEME_DESC": "এই আপুনাৰ ছিষ্টেমৰ ডিফল্ট মোড ব্যৱহাৰ কৰিব।",
    "DOCUMENTATION": "নথিপুকৰ",
    "DOC_DESC": "আমাৰ গভীৰ নথিপুকৰ প্ৰবন্ধসমূহ চাওক।",
    "FAQ_U": "সকলো সাধাৰণ প্ৰশ্ন চাওক",
    "FAQ_DESC": "Agent AIৰ বিষয়ে অধিক পৰ্যন্ত প্ৰশ্ন চাওক।",
    "KORE_ACADEMY": "Kore অকেডেমী",
    "KORE_ACA_DESC": "অকেডেমীৰ পাঠ্যক্ৰমসমূহৰ মাধ্যমে Agent AIৰ বাবে অধিক জানক।",
    "SEARCH": "অনুসন্ধান",
    "MY_BOT": "মোৰ Bot",
    "ASSIST": "সহায়",
    "TRANSCRIPT": "ট্ৰান্সক্ৰিপ্ট",
    "HISTORY": "ইতিহাস",
    "STARTOVER": "পুনঃ আৰম্ভ কৰক",
    "RESTART_INPUTS": "জড়িত ইনপুটসমূহ সৈতে পুনঃ আৰম্ভ কৰক",
    "ASKCUSTOMER": "গ্ৰাহকলৈ প্ৰশ্ন কৰক",
    "TELLCUSTOMER": "গ্ৰাহকক জানাওক",
    "WELCOME_MSG": "স্বাগতম বার্তা",
    "SEND": "পোহৰাওক",
    "SENT": "পোৱা দিয়া",
    "AWAITING": "প্ৰতিক্ৰিয়া অপেক্ষা কৰি আছে | জাৰী ৰাখিবলৈ টাইপ কৰক",
    "OVERRIDE": "জাৰী ৰাখিবলৈ টাইপ কৰক",
    "OVERRIDE_FILE": "জাৰী ৰাখিবলৈ ফাইল যোগ কৰক",
    "ACCEPT_RESPONSE": "প্ৰতিক্ৰিয়া গ্ৰহণ কৰা হ'ল",
    "AGENT_ENTERED": "এজেন্ট প্ৰবেশ কৰিছিল",
    "EXPECTED_FORMAT": "প্ৰত্যাশিত সৈতে",
    "INPUT_VALUES": "ইনপুট মানসমূহ",
    "RESTART": "পুনঃ আৰম্ভ কৰক",
    "PLAYBOOK": "প্লেবুক",
    "START_OVER": "পুনঃ আৰম্ভ কৰক",
    "AUTO_SCROLL_TOOLTIP":"সহায় টেব, মোৰ বটসমূহ, আৰু ট্ৰান্সক্ৰিপ্ট টেবসমূহে বিষয়বস্তুৰ স্বয়ংক্ৰিয় স্ক্ৰলিং নিয়ন্ত্ৰণ কৰে",
    "RESTART_CAPTURE": "জড়িত ইনপুটসমূহৰ সৈতে পুনঃ আৰম্ভ কৰক",
    "CANCEL": "বাতিল কৰক",
    "INTERRUPT_DIALOG": "বিৰামচ্ছেদিত চাৰ্চাৰ কাম",
    "RUN": "চলা",
    "RUN_AGENT": "এজেন্টৰ ইনপুটসমূহৰ সৈতে চলাওক",
    "STEP": "পদক্ষেপ",
    "DIALOG_TASK": "চাৰ্চাৰ কাম",
    "FAQ": "সকলো সাধাৰণ প্ৰশ্ন",
    "SNIPPET": "উত্তৰ",
    "ARTICLE": "Web পৃষ্ঠা",
    "FILE": "ফাইলসমূহ",
    "SUGGESTED": "সুপ্ৰদান কৰা",
    "ALL_DIALOG": "সকলো চাৰ্চাৰ কাম",
    "DIALOG_TEXT": "চাৰ্চা",
    "INTENT_IDENTIFIED": "গ্ৰাহকৰ বাক্য",
    "NOT_WHAT_LOOKING": "ভুল পৰামৰ্শ ?",
    "TAP_SEARCH": "সন্ধানৰ বাবে টেপ কৰক",
    "BOT": "বট",
    "CUSTOMER": "গ্ৰাহক",
    "YOU": "আপুনি",
    "TERMINATE_CONV": "চাৰ্চাৰ কাম বন্ধ কৰক",
    "TERMINATE_CONV_DESC": "আপুনি নিশ্চিত নেকি যে আপুনি চাৰ্চাৰ কাম বন্ধ কৰিব বিচ",
    "YES_TERMINATE": "হয়, বন্ধ কৰক",
    "NO_CANCEL": "নহয়, বাতিল কৰক",
    "OVERRIDE_CONTINUE": "ওভাৰ্ৰাইড মোডত মুখ্যান চলক",
    "SUMMARY_TEXT": "সাৰাংশ",
    "SUBMIT": "দাখিল কৰক",
    "INTERRUPT_OCCURED": "বিৰামচ্ছেদ ঘটিল",
    "IDENTIFIED_INTENT": "পছন্দ চিনাইছে",
    "INTERRUPT_DESC": "এই চলাৰ ফলত আপোনাৰ বৰ্তমান চাৰ্চাৰ কাম বন্ধ হৈ যাব।",
    "ACCEPT_RUN": "স্বীকৃতি দিৰি পূৰ্বক চলা",
    "RUN_LATER": "পাছৱাৰ চলা",
    "KNOW_MORE": "অধিক জানক",
    "MORE_TEXT": "অধিক",
    "LESS_TEXT": "কম",
    "VIEW_MORE": "অধিক দেখুৱাওক",
    "VIEW_LESS": "কম দেখুৱাওক",
    "SHOW_MORE_FAQ": "অধিক সাধাৰণ প্ৰশ্ন দেখুৱাওক",
    "SHOW_LESS_FAQ": "কম সাধাৰণ প্ৰশ্ন দেখুৱাওক",
    "SHOW_MORE_ARTICLE": "অধিক Web পৃষ্ঠা দেখুৱাওক",
    "SHOW_LESS_ARTICLE": "কম Web পৃষ্ঠা দেখুৱাওক",
    "SHOW_MORE_SNIPPET": "অধিক উত্তৰ দেখুৱাওক",
    "SHOW_LESS_SNIPPET": "কম উত্তৰ দেখুৱাওক",
    "SHOW_MORE_FILES": "অধিক ফাইলসমূহ দেখুৱাওক",
    "SHOW_LESS_FILES": "কম ফাইলসমূহ দেখুৱাওক",
    "VIEW_ALL_DIALOG": "সকলো চাৰ্চাসমূহ দেখুৱাওক",
    "VIEW_FEW_DIALOG": "কিছু চাৰ্চাসমূহ দেখুৱাওক",
    "HELP_FULL": "উপকাৰী?",
    "THANKYOU": "ধন্যবাদ!",
    "EXPAND_MORE": "বৃহৎ / অধিক",
    "CLOSE_TEXT": "বন্ধ কৰক",
    "STARTED": "আৰম্ভ কৰা হ'ল",
    "ENDED": "সমাপ্ত হোৱা হ'ল",
    "VIEW_FULL_ARTICLE": "Web পৃষ্ঠা দেখুৱাওক",
    "VIEW_FULL_FILE": "ফাইল দেখুৱাওক",
    "COPIED": "প্ৰতিলিপি কৰা হ'ল",
    "SENTI_ANALY": "ভাবনা বিশ্লেষণ",
    "WRONG_SUGGESTION": "ভুল পৰামৰ্শ",
    "INCORRECT_INTENT": "অশুদ্ধ ইচ্ছা",
    "ACCIDENTAL_CLICK": "অকস্মাত ক্লিক",
    "TIME_TAKING": "সময় লাগে",
    "OTHER": "অন্যান্য",
    "PLAYBOOK_EMPTY_MSG": "প্লেবুক নিৰ্বাচন কৰক",
    "PLAYBOOK_EMPTY_DESC": "এজেন্ট AI প্লেবুক লোড কৰিব নায়, সকলো উপলব্ধ প্লেবুকসমূহ ডায়নামিক হোৱাৰ কাৰণে। প্লেবুক এক্সেছ কৰিবলৈ 'প্লেবুক নিৰ্বাচন কৰক' ক্লিক কৰক।",
    "STAGE": "স্থিতি",
    "PROCEED_TO_CLOSE": "বন্ধ কৰিবলৈ এগৰাকী যাওঁক",
    "RECOMENDED_PLAYBOOK": "অনুমতি প্লেবুক",
    "PRIMARY_SCRIPTS": "প্ৰাথমিক স্ক্ৰিপ্টসমূহ",
    "DYNAMIC_SCRIPTS": "ডায়নামিক স্ক্ৰিপ্টসমূহ",
    "RESUME": "পুনঃ আৰম্ভ কৰা",
    "ENABLE_CLOSE": "বন্ধ কৰিবলৈ এগৰাকী বুটামটো ক্লিক কৰক",
    "LIST_VIEW": "তালিকা ভিউ",
    "TERMINATE": "সমাপ্ত কৰক",
    "MINIMIZE": "কমাওক",
    "MAXIMIZE": "বৃহৎ কৰক",
    "FILE_NAME":"ফাইলৰ নাম",
    "NO_SEARCH_RESULT": "কোনো সন্ধান ফলা পোৱা নাই",
    "SENTIMENT_AWAITING": "ভাবনাৰ জন্য অপেক্ষা কৰা হৈছে",
    "POSITIVE": "ইজাজতদাৰ",
    "NEGATIVE": "অসম্মত",
    "ASSOCIATED_WORK_NOTES": "গত সমাধান টোকা",
    "AGENT_JOINED_CONV": "এজেন্ট চৰ্চাৰ অংশগ্ৰহণ কৰিছিল",
    "AUTOSCROLL_ASSIST": "স্বয়ংক্ৰিয় স্ক্ৰল সহায় টেব সমল",
    "FILE_SIZE_MSG": "ফাইলৰ আকাৰ 25MBত অসম্ভব। অনুগ্ৰহ কৰি পুনৰায় চেষ্টা কৰক।",
    "OVERRIDE_BTN": "ওভাৰ্ৰাইড",
    "CHOOSE_FILE": "ফাইল বাছনি কৰক",
    "SUMMARY_ERROR_TEXT": "আমি দুঃখিত, কিন্তু এই চৰ্চাৰ বাবে সাৰাংশ",
    "ASK_A_QUESTION": "এটিয়া প্ৰশ্ন কৰক",
    "COPY" : "প্ৰতিলিপি",
    "TAB_TEXT":"কোনো টেব সক্ৰিয় কৰা হোৱা নাই! অনুগ্ৰহ কৰি অন্ততঃ এটা টেব সক্ৰিয় কৰক",
    "TELL_US_MORE": "অধিক ক'ব",
    "THANKS_FEEDBACK": "আপোনাৰ প্ৰতিক্ৰিয়াৰ বাবে ধন্যবাদ",
    "SOMETHING_WRONG": "কিবা এটা ভুল হৈছে",
    "CLICK_ERROR_DETAILS": "ত্ৰুটিৰ বিশদ বিবৰণ চাবলৈ ক্লিক কৰক",
    "NO_ACTIVE_PLAYBOOK": "কোনো সক্ৰিয় প্লেবুক নাই",
    "REPHRASE_QUESTION": "আপুনি আপোনাৰ প্ৰশ্নটো পুনৰাবৃত্তি কৰিবনে বা আন একো সোধিবনে?",
    "INTERNAL_INFO": "অভ্যন্তৰীণ তথ্য",
    "SOURCES": "উৎসসমূহ",
    "CONVERSATION_SUMMARY": "কথোপকথনৰ সংক্ষিপ্তসাৰ",
    "WAITING": "অপেক্ষা কৰা হৈছে",
    "WIDGET_DISABLED": "উইজেট অক্ষম কৰা হৈছে",
    "AI_SETTINGS_DISABLED": "AI ছেটিংসমূহ অক্ষম কৰা হৈছে! অনুগ্ৰহ কৰি AI প্ৰশাসকক সংযোগ কৰক",
    "SERVER_CONNECTION_ERROR": "চাৰ্ভাৰৰ লগত সংযোগ কৰাৰ সময়ত ভুল হৈছে",
    "VIEW": "চাওক",
    "ATTACHMENT_INPUT": "সংলগ্ন নথিপত্ৰ প্ৰৱেশ",
    "TYPE_SUMMARY": "সাৰাংশ লিখক",
    "VIEW_FULL_ARTICLE_2": "সম্পূৰ্ণ প্ৰবন্ধ চাওক",
    "VIEW_FULL_FILE_2": "সম্পূৰ্ণ নথিপত্ৰ চাওক",
    "BY":"দ্বাৰা",
    "GENERATE_SUMMARY": "সাৰাংশ সৃষ্টি কৰক",
    PREV_SUMMARIES: "পূৰ্বে সৃষ্টি কৰা সাৰাংশ",
    DIALOG_WORKFLOWS: "ডায়লগ ৱৰ্কফ্ল'",
    SHOW_ALL_DIALOG: "সকলো ডায়লগ টাস্ক দেখুৱাওক",
    SHOW_ALL_DIALOGS: "সকলো ডায়লগ দেখুৱাওক",
    CUSTOM_TAB: "কাষ্টম টেব",
    AGENT_INPUT: "এজেন্টৰ ইনপুট",
    "CUSTOM_EMPTY_MSG" : "কোনো সক্ৰিয় প্ৰক্রিয়া বিদ্যমান নাই",
    "CUSTOM_TAB_DESC" : "এটা প্ৰক্রিয়া আৰম্ভ কৰিবলৈ, তালিকাৰ শেষত থকা এটা প্ৰক্রিয়া চাওক।",
    "SUBMIT_OVERALL_FEEDBACK" : "সম্পূৰ্ণ প্ৰতিক্ৰিয়া দাখিল কৰক",
    "FEEDBACK_POPUP_SUBTITLE" : "আপোনাৰ উইজেট আৰু এই বৈশিষ্ট্যসমূহৰ বাবে আপোনাৰ সন্তুষ্টতা কিমান?",
    "FEEDBACK_SATISFIED" : "সন্তুষ্ট",
    "FEEDBACK_UNSATISFIED" : "অসন্তুষ্ট",
    "FEEDBACK_PROVIDE_REASONS" : "আমাৰ বিষয়ে আমি আমি কিছু বলিব নাই",
    "FEEDBACK_TITLE" : "প্ৰতিক্ৰিয়া",
    "AGENTIC_THINKING" : "চিন্তা কৰা",
    "AGENTIC_AGENT_TITLE" : "এজেণ্ট",
    "AGENTIC_COPILOT_MODE_TITLE" : "এজেণ্টিক কপাইলট ম'ড",
    "AGENTIC_SENDING_MESSAGE" : "প্ৰেৰণ কৰা হৈছে...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot সক্ৰিয়ভাৱে আপোনাৰ কথোপকথন শুনি আছে আৰু স্বয়ংক্ৰিয়ভাৱে সহায় কৰিবলৈ সাজু",
    "AGENTIC_SEARCH_RESULTS" : "এজেণ্ট ফলাফল"
}